import { useEffect } from "react"

export const InvalidDomainAccess = () => {

    useEffect(() => {
        sessionStorage.clear();
    },[]);

    return (
        <div className="main-container">
            <div className="error-container" style={{textAlign: 'center'}}>
                <img src="https://cdn-icons-png.freepik.com/512/18607/18607931.png" style={{width: 200 , marginBottom: 32}} alt=""></img>
                <h1 style={{textAlign: 'center', color: 'white', marginTop: 32, marginBottom: 18 , fontSize: 48}}>Access Denied!</h1>
                <h5 style={{ color: 'white' }}>Please contact support or try again from an approved domain..</h5>
            </div>
        </div>
    )
}
